import { umspannwerk } from '../../../../utils/apiTypes';
import { umspannwerkState } from './umspannwerkeTypes';
import { AnyAction, createSlice, PayloadAction, ThunkAction } from "@reduxjs/toolkit";
import { getWithAuth, putWithAuth, deleteWithAuth } from "../../../../utils/api";
import type { RootState, AppDispatch } from "../../../../app/store";
import { logError } from "../../../../utils/utils";
import { openSnackbar } from "../../../../features/snackbar/globalSnackbarSlice";
import { GridSortModel } from '@material-ui/data-grid';
import { errorHandler } from '../../../../utils/errorHandling';

export const umspannwerkDummy: umspannwerk
  = {
  name: "",
  kuerzel: "",
  breitengrad: 0,
  laengengrad: 0,
  kommentar: "",
  zugeordnet: false,
};

const initialState: umspannwerkState
  = {
  umspannwerkListe: [],
  altesUmspannwerk: umspannwerkDummy,
  aktuellesUmspannwerk: umspannwerkDummy,
  newEntry: false,
  editEntry: false,
  editDirty: 0,
  viewMode: false,
  error: [],
  listLoading: false,
  sorting: [
    {
      field: 'name',
      sort: 'asc',
    },
  ]
};

const umspannwerkeSlice = createSlice({
  name: "umspannwerk",
  initialState,
  reducers:
  {
    updateUmspannwerke: (state, action: PayloadAction<umspannwerk>) => {
      const updateIndex = state.umspannwerkListe.findIndex(
        (x: umspannwerk) => x.name == action.payload.name
      );
      const firstPart = state.umspannwerkListe.slice(0, updateIndex);
      let lastPart = Array<umspannwerk>();
      if (updateIndex + 1 < state.umspannwerkListe.length)
        lastPart = state.umspannwerkListe.slice(updateIndex + 1);
      state.umspannwerkListe = [...firstPart, action.payload, ...lastPart].sort((a, b) => a.name.localeCompare(b.name));
    },
    removeFromUmspannwerke: (state, action: PayloadAction<umspannwerk>) => {
      const updateIndex = state.umspannwerkListe.findIndex(
        (x) => x.name == action.payload.name
      );
      const firstPart = state.umspannwerkListe.slice(0, updateIndex);
      let lastPart = Array<umspannwerk>();
      if (updateIndex + 1 < state.umspannwerkListe.length)
        lastPart = state.umspannwerkListe.slice(updateIndex + 1);
      state.umspannwerkListe = [...firstPart, ...lastPart];
    },
    addAktuellesUmspannwerkToUmspannwerke: (state) => {
      const umspannwerkArray = state.umspannwerkListe;
      umspannwerkArray.push(state.aktuellesUmspannwerk);
      state.umspannwerkListe = [...umspannwerkArray].sort((a, b) => a.name.localeCompare(b.name));
    },
    setUmspannwerke: (state, action: PayloadAction<Array<umspannwerk>>) => {
      state.umspannwerkListe = action.payload;
    },
    setAktuellesUmspannwerk: (state, action: PayloadAction<umspannwerk>) => {
      state.aktuellesUmspannwerk = action.payload;
      state.altesUmspannwerk = action.payload;
    },
    setAltesUmspannwerk: (state, action: PayloadAction<umspannwerk>) => {
      state.altesUmspannwerk = action.payload;
    },
    resetAktuellesUmspannwerk: (state) => {
      state.aktuellesUmspannwerk = state.altesUmspannwerk;
    },
    setEditEntry: (state) => {
      state.editEntry = true;
    },
    resetEditEntry: (state) => {
      state.editEntry = false;
    },
    setNewEntry: (state) => {
      state.newEntry = true;
    },
    resetNewEntry: (state) => {
      state.newEntry = false;
    },
    resetEditDirty: (state) => {
      state.editDirty = 0;
    },
    setViewMode: (state) => {
      state.viewMode = true;
    },
    resetViewMode: (state) => {
      state.viewMode = false;
    },
    setError: (state, action: PayloadAction<string>) => {
      if (!state.error.includes(action.payload)) {
        state.error.push(action.payload);
      }
    },
    resetError: (state, action: PayloadAction<string>) => {
      if (state.error.includes(action.payload)) {
        state.error.splice(state.error.indexOf(action.payload), 1)
      }
    },
    setName: (state, action: PayloadAction<string>) => {
      state.aktuellesUmspannwerk.name = action.payload;
      state.editDirty =
        state.aktuellesUmspannwerk.name ==
          state.altesUmspannwerk.name
          ? state.editDirty - 1
          : state.editDirty + 1;
    },
    setKuerzel: (state, action: PayloadAction<string>) => {
      state.aktuellesUmspannwerk.kuerzel = action.payload;
      state.editDirty =
        state.aktuellesUmspannwerk.kuerzel ==
          state.altesUmspannwerk.kuerzel
          ? state.editDirty - 1
          : state.editDirty + 1;
    },
    setBreitengrad: (state, action: PayloadAction<number>) => {
      state.aktuellesUmspannwerk.breitengrad = action.payload;
      state.editDirty =
        state.aktuellesUmspannwerk.breitengrad ==
          state.altesUmspannwerk.breitengrad
          ? state.editDirty - 1
          : state.editDirty + 1;
    },
    setLaengengrad: (state, action: PayloadAction<number>) => {
      state.aktuellesUmspannwerk.laengengrad = action.payload;
      state.editDirty =
        state.aktuellesUmspannwerk.laengengrad ==
          state.altesUmspannwerk.laengengrad
          ? state.editDirty - 1
          : state.editDirty + 1;
    },
    setKommentar: (state, action: PayloadAction<string>) => {
      state.aktuellesUmspannwerk.kommentar = action.payload;
      state.editDirty =
        state.aktuellesUmspannwerk.kommentar ==
          state.altesUmspannwerk.kommentar
          ? state.editDirty - 1
          : state.editDirty + 1;
    },
    setListLoading: (state, action: PayloadAction<boolean>) => {
      state.listLoading = action.payload;
    },
    setSorting: (state, action: PayloadAction<GridSortModel>) => {
      state.sorting = action.payload;
    },
  }
});


//Selectors
//======================================================================
export const selectUmspannwerkListe = (state: RootState): Array<umspannwerk> =>
  state.umspannwerk.umspannwerkListe;
export const selectAktuellesUmspannwerk = (state: RootState): umspannwerk =>
  state.umspannwerk.aktuellesUmspannwerk;
export const selectEditEntry = (state: RootState): boolean =>
  state.umspannwerk.editEntry;
export const selectNewEntry = (state: RootState): boolean => state.umspannwerk.newEntry;
export const selectEditDirty = (state: RootState): number =>
  state.umspannwerk.editDirty;
export const selectViewMode = (state: RootState): boolean => state.umspannwerk.viewMode;
export const selectError = (state: RootState): boolean => state.umspannwerk.error.length > 0;
export const selectListLoading = (state: RootState): boolean => state.umspannwerk.listLoading;
export const selectSorting = (state: RootState): GridSortModel => state.umspannwerk.sorting;

//Actions
//=====================================================================

export const getUmspannwerke = () => (dispatch: AppDispatch): void => {
  dispatch(setListLoading(true));
  getWithAuth("UMSPANNWERK", {})
    .then((response) => {
      dispatch(setUmspannwerke(response));
    })
    .catch((error) => {
      logError(error);
      errorHandler(error, dispatch);
    }).finally(() => dispatch(setListLoading(false)));
};

export const updateUmspannwerk = (aktuellesUmspannwerk: umspannwerk): ThunkAction<void, RootState, unknown, AnyAction> => (
  dispatch: AppDispatch
) => {
  dispatch(setListLoading(true));
  putWithAuth("UMSPANNWERKID" , {}, aktuellesUmspannwerk, aktuellesUmspannwerk.name)
    .then(() => {
      dispatch(
        openSnackbar({
          message: `Umspannwerk mit Name ${aktuellesUmspannwerk.name} wurde erfolgreich geändert.`,
          severity: "success",
          duration: 6000,
        })
      );
      dispatch(setAltesUmspannwerk(aktuellesUmspannwerk));
      dispatch(updateUmspannwerke(aktuellesUmspannwerk));
      dispatch(resetEditEntry());
      dispatch(resetNewEntry());
      dispatch(resetEditDirty());
    }
    )
    .catch((error) => {
      logError(error);
      errorHandler(error, dispatch);
    }).finally(() => dispatch(setListLoading(false)));

};

export const updateAktuellesUmspannwerk = (aktuellesUmspannwerk: umspannwerk): ThunkAction<void, RootState, unknown, AnyAction> => (
  dispatch: AppDispatch
) => {
  dispatch(setAktuellesUmspannwerk(aktuellesUmspannwerk));
  dispatch(setViewMode());
};

export const discardChanges = () => (dispatch: AppDispatch): void => {
  dispatch(resetAktuellesUmspannwerk());
  dispatch(resetEditEntry());
  dispatch(resetNewEntry());
  dispatch(resetEditDirty());
};

export const discardNew = () => (dispatch: AppDispatch): void => {
  dispatch(resetAktuellesUmspannwerk());
  dispatch(resetEditEntry());
  dispatch(resetNewEntry());
  dispatch(resetEditDirty());
  dispatch(resetViewMode());
};

export const startNewEntry = () => (dispatch: AppDispatch): void => {
  dispatch(setNewEntry());
  dispatch(setAktuellesUmspannwerk(umspannwerkDummy));
  dispatch(setEditEntry());
  dispatch(setViewMode());
};

export const createUmspannwerk = (aktuellesUmspannwerk: umspannwerk): ThunkAction<void, RootState, unknown, AnyAction> => (
  dispatch: AppDispatch
) => {
  dispatch(setListLoading(true));
  putWithAuth("UMSPANNWERKID", {}, aktuellesUmspannwerk, aktuellesUmspannwerk.name)
    .then(() => {
      dispatch(
        openSnackbar({
          message: `Umspannwerk mit Name ${aktuellesUmspannwerk.name} wurde erfolgreich angelegt.`,
          severity: "success",
          duration: 6000,
        })
      );
      dispatch(addAktuellesUmspannwerkToUmspannwerke());
      dispatch(setAktuellesUmspannwerk(umspannwerkDummy));
      dispatch(resetEditEntry());
      dispatch(resetNewEntry());
      dispatch(resetEditDirty());
      dispatch(resetViewMode());
    }
    )
    .catch((error) => {
      logError(error);
      errorHandler(error, dispatch);
    }).finally(() => dispatch(setListLoading(false)));

};

export const deleteUmspannwerk = (aktuellesUmspannwerk: umspannwerk): ThunkAction<void, RootState, unknown, AnyAction> => (
  dispatch: AppDispatch
) => {
  dispatch(setListLoading(true));
  deleteWithAuth("UMSPANNWERKID", {}, aktuellesUmspannwerk.name )
    .then(() => {
      dispatch(setAktuellesUmspannwerk(umspannwerkDummy));
      dispatch(removeFromUmspannwerke(aktuellesUmspannwerk));
      dispatch(resetEditEntry());
      dispatch(resetEditDirty());
      dispatch(resetViewMode());
      dispatch(openSnackbar({
        message: `Umspannwerk mit Name ${aktuellesUmspannwerk.name} wurde erfolgreich gelöscht.`,
        severity: "success",
        duration: 6000,
      }));
    }
    )
    .catch((error) => {
      logError(error);
      errorHandler(error, dispatch);
    }).finally(() => dispatch(setListLoading(false)));
};

export const {
  removeFromUmspannwerke,
  setUmspannwerke,
  setAktuellesUmspannwerk,
  resetAktuellesUmspannwerk,
  setAltesUmspannwerk,
  updateUmspannwerke,
  setEditEntry,
  resetEditEntry,
  setNewEntry,
  resetNewEntry,
  resetEditDirty,
  setViewMode,
  resetViewMode,
  setError,
  resetError,
  setName,
  setKuerzel,
  setBreitengrad,
  setLaengengrad,
  setKommentar,
  addAktuellesUmspannwerkToUmspannwerke,
  setListLoading,
  setSorting
} = umspannwerkeSlice.actions;
export default umspannwerkeSlice.reducer;